import { notify, UploadDragger } from "components/common"
import { useMeetingVerificationMutation } from "features/tasks/api"
import { t } from "i18next"
const MeetingVerificationAttachmentUploader = props => {
  const {
    setFiles,
    name,
    files,
    setField,
    fieldName,
    maxCount = 3,
    allowedFileSize = 5,
    imageType = "image/png, image/jpeg, image/jpg",
    disabled,
    verifyMeeting = false,
    taskType,
    setIsAttachmentValidation = () => {},
  } = props
  const [meetingVerification, { isLoading }] = useMeetingVerificationMutation()

  const onUpload = async ({ name, file }) => {
    setIsAttachmentValidation(true)
    try {
      const response = await meetingVerification({ name, file, taskType }).unwrap()
      response?.data?.status === "rejected"
        ? notify.error(response?.data?.reason || t("Image has been rejected"))
        : notify.success(response?.data?.reason || t("Image has been verified"))
      setFiles(encodedFile => [...encodedFile, { name, file, status: response?.data?.status }])
    } catch (error) {
      notify.error(error?.message || "")
    } finally {
      setIsAttachmentValidation(false)
    }
  }

  return (
    <div style={{ width: "339px" }}>
      <UploadDragger
        name={name}
        files={files}
        setFiles={setFiles}
        fieldName={fieldName}
        setField={setField}
        disabled={disabled}
        allowedFileSize={allowedFileSize}
        maxCount={maxCount}
        imageType={imageType}
        isLoading={isLoading}
        {...(verifyMeeting && { meetingValidationRequest: onUpload })}
      />
    </div>
  )
}
export default MeetingVerificationAttachmentUploader
